var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',_vm._b({model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},'el-tabs',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }